<template>
  <div class='ilots'>
    <v-breadcrumb />
    <div class='ct-flex-row ct-flex-wrap'>
      <BlocIlot v-for='ilot in ilots' :key='ilot.id_ilot' :ilot='ilot' :id-exploitation='idExploitation' @remove='deleteIlot' />
      <a v-can:edit-exploitation class='item-bloc item-add flex justify-center flex-column items-center' href='#' @click.prevent='addIlot'>Ajouter un îlot</a>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import BlocIlot from '@/components/BlocIlot'

export default {
  name: 'ExploitationIlotsList',

  components: {
    BlocIlot
  },

  props: {
    idExploitation: {
      type: String,
      require: true
    }
  },

  created () {
    this.$store.dispatch('referentiel/loadTypeMateriels')
  },

  computed: {
    ilots () {
      return this.$store.getters.getIlots
    }
  },

  methods: {
    ...mapActions(['createIlot', 'removeIlot']),
    ...mapActions('prompt', ['prompt']),
    addIlot () {
      this.prompt({
        title: 'Ajout îlot',
        label: "Nom de l'îlot",
        okText: 'Créer'
      }).then((resultat) => {
        if (resultat !== false) {
          this.createIlot({
            idExploitation: this.idExploitation,
            nom: resultat
          })
            .then(newId => {
              this.$router.push({ name: 'ilot', params: { idExploitation: this.idExploitation, idIlot: newId } })
            })
        }
      })
    },
    deleteIlot (ilot) {
      this.removeIlot({
        idExploitation: this.idExploitation,
        idIlot: ilot.id_ilot
      })
    }
  }
}
</script>
